import {Component, Input} from "@angular/core";

@Component({
    selector: "wbo-edit-grid-save-action",
    styleUrls: ["./edit-grid-save-action.component.scss"],
    templateUrl: "./edit-grid-save-action.component.html"
})
export class EditGridSaveActionComponent {
    @Input() title: string;
}
